import { render, staticRenderFns } from "./PeopleActionCollection.vue?vue&type=template&id=3505a869"
import script from "./PeopleActionCollection.vue?vue&type=script&lang=ts"
export * from "./PeopleActionCollection.vue?vue&type=script&lang=ts"
import style0 from "./PeopleActionCollection.vue?vue&type=style&index=0&id=3505a869&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports